import { useAuth } from "@/context/AuthContext";
import { Link } from "react-router-dom";
import { User, Mail, Phone, LogOut, Ticket, Heart, BellRing } from "lucide-react";
import ZButton from "@/components/ZButton";

export default function ProfilePage() {
  const { user, logout } = useAuth();

  if (!user) {
    return (
      <div className="z-container" data-testid="profile-page-guest">
        <h1 className="z-page-title">Profil</h1>
        <p className="z-page-sub">Connectez-vous pour gérer votre profil.</p>
        <Link to="/login" className="z-btn z-btn-primary" data-testid="profile-login-btn">Se connecter</Link>
      </div>
    );
  }

  return (
    <div className="z-container" data-testid="profile-page">
      <h1 className="z-page-title">Profil</h1>
      <p className="z-page-sub">Gérez vos informations personnelles.</p>

      <div className="z-card" style={{ padding: 24 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 24 }}>
          <div style={{ width: 64, height: 64, borderRadius: "50%", background: "var(--z-teal)", color: "white", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 26, fontWeight: 700 }}>
            {user.name?.[0]?.toUpperCase() || "?"}
          </div>
          <div>
            <div style={{ fontWeight: 700, fontSize: 18 }} data-testid="profile-name">{user.name}</div>
            <div style={{ fontSize: 13, color: "var(--z-muted)" }}>Rôle : {user.role}</div>
          </div>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 0", borderTop: "1px solid var(--z-border)" }}>
          <Mail size={16} color="var(--z-muted)" />
          <span data-testid="profile-email">{user.email}</span>
        </div>
        {user.phone && (
          <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 0", borderTop: "1px solid var(--z-border)" }}>
            <Phone size={16} color="var(--z-muted)" />
            <span data-testid="profile-phone">{user.phone}</span>
          </div>
        )}
        {user.org_name && (
          <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 0", borderTop: "1px solid var(--z-border)" }}>
            <User size={16} color="var(--z-muted)" />
            <span>{user.org_name} — {user.city}</span>
          </div>
        )}
      </div>

      <div style={{ marginTop: 18, display: "flex", flexDirection: "column", gap: 10 }}>
        <Link to="/tickets" className="z-btn z-btn-outline" data-testid="profile-tickets-link">
          <Ticket size={16} /> Mes billets
        </Link>
        <Link to="/engagements" className="z-btn z-btn-outline" data-testid="profile-engagements-link">
          <Heart size={16} /> Mes engagements
        </Link>
        <Link to="/profile/notifications" className="z-btn z-btn-outline" data-testid="profile-notifications-link">
          <BellRing size={16} /> Notifications
        </Link>
        <Link to="/redeem" className="z-btn z-btn-outline" data-testid="profile-redeem-link">
          Saisir un code d&apos;invitation
        </Link>
        <ZButton variant="danger" onClick={logout} data-testid="profile-logout-btn">
          <LogOut size={16} /> Se déconnecter
        </ZButton>
      </div>
    </div>
  );
}
